export default __webpack_public_path__ + "static/banner-fb6cd84d9ef10d222aef9ed5caaf241b.png";